module.exports = __webpack_public_path__ + "img/team_martin_bustgaard_marsell.08137afa.webp";